import React from 'react';
import { Wrench } from 'lucide-react';

const MaintenancePage: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-center px-4">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full flex flex-col items-center">
                <div className="bg-orange-100 p-4 rounded-full mb-4">
                    <Wrench className="w-12 h-12 text-orange-500" />
                </div>
                <h1 className="text-2xl font-bold text-gray-800 mb-2">Sedang Dalam Pemeliharaan</h1>
                <p className="text-gray-600">
                    Sistem sedang melakukan pembaruan rutin. <br />
                    Silakan kembali lagi nanti setelah waktu pemeliharaan selesai.
                </p>
            </div>
        </div>
    );
};

export default MaintenancePage;